/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Home_Faq_4Inputs */

const en_settings_home_faq_4 = /** @type {(inputs: Settings_Home_Faq_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need contact management access for a fund to modify user roles.
            You can review available roles and their permissions in our`)
};

/**
* | output |
* | --- |
* | "You need contact management access for a fund to modify user roles. You can review available roles and their permissions in our" |
*
* @param {Settings_Home_Faq_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_home_faq_4 = /** @type {((inputs?: Settings_Home_Faq_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Home_Faq_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_home_faq_4(inputs)
});